import { FormattedMessage } from 'react-intl';
import { PaymentDetailFailedTableSubText, SubTextStyle } from '../../styled';

export const FailedTableSubHeading = (): React.JSX.Element => (
  <SubTextStyle>
    <PaymentDetailFailedTableSubText>
      <FormattedMessage
        defaultMessage="The following credit card payments failed and no virtual card was created for them. Click "
        description="failed grid header sub text1"
      />{' '}
      <b>
        <FormattedMessage
          defaultMessage="Retry Selected"
          description="retry button text to resubmit the failed records"
        />
      </b>{' '}
      <FormattedMessage
        defaultMessage="to resend the payment"
        description="failed grid header sub text2"
      />
    </PaymentDetailFailedTableSubText>
  </SubTextStyle>
);
